<template>

    <div class="container">

        <app-head title="Cart" />

        <div class="my-4">
            <h1>{{ __('Cart') }}</h1>
        </div>

        <template v-if="form.cart_items_by_supplier.length === 0">
            <div>
                {{ __('Ihr Warenkorb ist noch leer.') }}
            </div>
        </template>

        <template v-else>

            <updated-cart-items :updated-cart-items="updatedCartItems" />

            <form @submit.prevent="updateCart">

                <cart-items
                    v-for="(group, supplierId) in form.cart_items_by_supplier"
                    :form="form"
                    :group="group"
                    :key="supplierId"
                    />

                <div class="pb-3 mb-4 border-bottom">
                    <div class="text-end">
                        {{ __('Gesamtsumme') }}
                        <div class="h1">
                            {{ totalAmount | localizeAmount }}
                        </div>
                        <div>
                            {{ __('ggf. zzgl. Versandkosten') }}
                        </div>
                    </div>
                </div>

                <div class="row g-3 flex-md-row-reverse">
                    <div class="col-md-6 text-md-end">
                        <button 
                            type="submit"
                            class="btn btn-lg btn-outline-primary flex-grow-1 flex-md-grow-0" 
                            :disabled="form.processing" 
                            v-if="form.isDirty"
                            >
                            <i class="bi bi-arrow-clockwise"></i>
                            {{ __('Aktualisieren') }}
                        </button>
                        <template v-else>
                            <template v-if="$page.props.auth.user.can.checkout">
                                <inertia-link :href="route('checkout.index')" class="btn btn-lg btn-primary text-white flex-grow-1 flex-md-grow-0">
                                    <i class="bi bi-cart2 fs-5 me-2"></i>
                                    <span class="" v-html="__('Bestellen bei <u><b>allen</b></u> Lieferanten')">
                                    </span>
                                </inertia-link>
                                <div class="my-2 small">
                                    {{ __('Sie können Ihre Bestellung im nächsten Schritt noch einmal überprüfen.') }}
                                </div>
                            </template>
                            <template v-else>
                                {{ __('Sie haben keine Berechtigung für weitere Schritte.') }}
                            </template>
                        </template>
                    </div>
                    <div class="col-md-6">
                        <inertia-link :href="route('cart.optimize')" class="btn btn-lg btn-success flex-grow-1 flex-md-grow-0">
                            {{ __('Warenkorb optimieren') }}
                        </inertia-link>
                        <div class="my-2 small">
                            {{ __('Optimiert Ihren Warenkorb auf den günstigsten Gesamtpreis unter Berücksichtigung alternativer Lieferanten auf dem Marktplatz.') }}
                        </div>
                    </div>
                </div>

            </form>

        </template>

        <sticky-message :message="$page.props.flash.success" />

    </div>

</template>

<script>

    import CartItems from './CartItems';
    import UpdatedCartItems from './UpdatedCartItems';

    import StickyMessage from '@/shared/StickyMessage';

    export default {
        props: [
            'totalAmount',
            'updatedCartItems',
            'cartItemsBySupplier',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    cart_items_by_supplier: this.cartItemsBySupplier,
                }),
            }
        },
        components: {
            CartItems,
            UpdatedCartItems,
            StickyMessage,
        },
        watch: {

        },
        methods: {
            updateCart() {
                this.$inertia.post(route('cart.update-cart'), this.form, {preserveScroll: true, preserveState: false});
            }
        },
    }
</script>